export default {
  // Basis Informationen des Model
	model: {
		id: 0,
		firstname: "",
		lastname: "",
		username: "",
		password: "",
		permission_id: 0,
		role_id: 0,
		superior_id: 0,
		superior_name: "",

		rights: {
			dashboard: 0,
			deceaseds: 0,
			customers: 0,
			graves: 0,
			areas: 0,
			crematories: 0,
			undertakers: 0,
			users: 0,
			roles: 0,

			area_categories: 0,
			grave_categories: 0,
			burial_types: 0,
			denominations: 0
		},

		rightValues: {
			dashboard: "",
			deceaseds: "",
			customers: "",
			graves: "",
			areas: "",
			crematories: "",
			undertakers: "",
			users: "",
			roles: "",

			area_categories: "",
			grave_categories: "",
			burial_types: "",
			denominations: ""
		},

		role: {
			dashboard: "Kein Zugriff",
			deceaseds: "Kein Zugriff",
			customers: "Kein Zugriff",
			graves: "Kein Zugriff",
			areas: "Kein Zugriff",
			crematories: "Kein Zugriff",
			undertakers: "Kein Zugriff",
			users: "Kein Zugriff",
			roles: "Kein Zugriff",

			area_categories: "Kein Zugriff",
			grave_categories: "Kein Zugriff",
			burial_types: "Kein Zugriff",
			denominations: "Kein Zugriff"
		}
	},

	clear () {
		this.model.id = 0
		this.model.firstname = ""
		this.model.lastname = ""
		this.model.username = ""
		this.model.password = ""
		this.model.permission_id = ""
		this.model.role_id = ""

		this.addresses = []
		this.contacts = []

		this.model.forced = true

		this.model.rights = {}
		this.model.rightValues = {}
		this.model.role = {}

		this.model.superior_id = 0
		this.model.superior_name = ""
	},

	name: "users",

	// Die Spalten der Tabelle
	cols: [
		{name: "Vorname", json: "firstname", type: "text"},
		{name: "Nachname", json: "lastname", type: "text"}
	],

	relations: [
		"zips",
		"contact_types",
		"address_types",
		"roles"
	],

	copy (aModel) {
		this.model.id = aModel.id
		this.model.firstname = aModel.firstname
		this.model.lastname = aModel.lastname
		this.model.username = aModel.username
		this.model.permission_id = aModel.permission_id
		this.model.role_id = aModel.role_id
		this.model.role_name = aModel.role_name

		this.model.rights = aModel.rights

		this.model.forced = true

		this.model.rights = aModel.rights
		this.model.rightValues = {}
		this.model.role = {}

		this.model.superior_id = aModel.superior_id
		this.model.superior_name = aModel.superior_name

		if (typeof aModel.addresses !== "undefined") {
		  this.addresses = aModel.addresses
		}

		if (typeof aModel.contacts !== "undefined") {
		  this.contacts = aModel.contacts
		}
	},

	validate () {
		this.model.role_id = isNaN(parseInt(this.model.role_id)) ? 0 : parseInt(this.model.role_id)

		return true
	},

	validateModel () {
		return true
	},

	// Beziehungen zu anderen Models
	addresses: [],
	contacts: []
}



// WEBPACK FOOTER //
// ./src/models/users.js